export default __webpack_public_path__ + "static/media/eyes.954e95d2.jpeg";